<template>
	<div class="admin-container">
		<div class="admin-header">
			<h2>后台管理</h2>
		</div>
		<div class="admin-tabs">
			<div 
				class="tab-item" 
				:class="{ active: activeTab === 'lottery' }" 
				@click="activeTab = 'lottery'"
			>
				抽奖管理
			</div>
			<div 
				class="tab-item" 
				:class="{ active: activeTab === 'users' }" 
				@click="activeTab = 'users'"
			>
				用户管理
			</div>
			<div 
				class="tab-item" 
				:class="{ active: activeTab === 'settings' }" 
				@click="activeTab = 'settings'"
			>
				系统设置
			</div>
		</div>
		<div class="admin-content">
			<lottery-admin v-if="activeTab === 'lottery'" />
			<div v-else-if="activeTab === 'users'" class="coming-soon">
				<p>用户管理功能开发中...</p>
			</div>
			<div v-else-if="activeTab === 'settings'" class="coming-soon">
				<p>系统设置功能开发中...</p>
			</div>
		</div>
	</div>
</template>

<script>
import lotteryAdmin from './lottery-admin.vue'

export default {
	name: 'admin',
	components: {
		lotteryAdmin
	},
	data() {
		return {
			activeTab: 'lottery'
		}
	},
	mounted() {
		const groupId = this.$store.getters.group_id
		if (groupId != 0) {
			this.$router.push('/')
			this.$message.warning('无权限访问')
		}
	}
}
</script>

<style scoped>
.admin-container {
	min-height: 100vh;
	background: #f5f5f5;
	padding: 20px;
}

.admin-header {
	background: #fff;
	padding: 20px;
	border-radius: 8px;
	margin-bottom: 20px;
}

.admin-header h2 {
	margin: 0;
	color: #333;
	font-size: 24px;
}

.admin-tabs {
	display: flex;
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	margin-bottom: 20px;
}

.tab-item {
	flex: 1;
	padding: 15px 20px;
	text-align: center;
	cursor: pointer;
	border-bottom: 3px solid transparent;
	transition: all 0.3s;
}

.tab-item:hover {
	background: #f0f0f0;
}

.tab-item.active {
	border-bottom-color: #409eff;
	color: #409eff;
	font-weight: bold;
}

.admin-content {
	background: #fff;
	border-radius: 8px;
	padding: 20px;
}

.coming-soon {
	text-align: center;
	padding: 60px 20px;
	color: #999;
	font-size: 16px;
}
</style>
